import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const zohoDesk = defineConnector({
  identifier: "zohoDesk",
  name: "Zoho Desk",
  tagLine: "Customer support and ticketing",
  logo,
  protocol: "http",
  tags: ["communication", "productivity"],
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.accessToken,
        scheme: "Zoho-oauthtoken",
      },
      { name: "orgId", value: app.config.orgId },
    ]),
  steps: [
    {
      title: "Get your Zoho Desk API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "In Zoho Desk, create an OAuth access token and copy your organization ID. The API sends the token in the `Authorization` header using the `Zoho-oauthtoken` scheme and also requires the `orgId` header.",
        },
      ],
    },
    {
      title: "Enter your Zoho Desk details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          placeholder: "https://desk.zoho.com/api/v1",
          target: { kind: "configuration", field: "apiBaseUrl" },
        },
        {
          kind: "input",
          label: "Organization ID",
          required: true,
          target: { kind: "configuration", field: "orgId" },
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiBaseUrl }) =>
      `${apiBaseUrl || "https://desk.zoho.com/api/v1"}/tickets?limit=1`,
  },
  defaultUrlPattern: ({ apiBaseUrl }) =>
    urlToPattern(apiBaseUrl, "https://[^/]*\\.zoho\\.[^/]*/api/.*"),
});
